import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import { Link, useNavigate } from 'react-router';
import InfoCardsVendor from '../Components/Vendors/InfoCardsVendor';
import { useVendorStore } from '../store/useVendorStore';
import { Box, Button, Modal, Pagination, Stack, TableCell, TableRow, Typography } from '@mui/material';
import Loader from '../Components/loader/Loader';

export default function Vendors() {
    const navigate = useNavigate()
    const { getAllVendor, loading, deletevendor, vendor, getAnalytics, dowloadVendorList } = useVendorStore()
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState('');
    const [itemId, setItemId] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [field, setField] = useState('');
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteID] = useState(null);
    const [analytics, setAnalytics] = useState(null)

    const handleEdit = (id) => {
        navigate(`/vendor/add-vendor?id=${encodeURIComponent(id)}`);
    };

    const getAllVendorFunctioncaller = async () => {
        const data = await getAllVendor(pageNumber, pageSize, search, 'vendorName')
        if (data) {
            setTotalPages(data?.totalPages)
        }
    }

    const handleChangePagination = (event, value) => {
        setPageNumber(value);
    };

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleDelete = (id) => {
        setDeleteID(id)
        setOpen(true)
    }

    const handleConfirmDelete = async () => {
        try {
            const res = await deletevendor(deleteId)
            setOpen(false)
        } catch (error) {
            console.log(error)
        }
    }

    const getAnalyticsFunctioncaller = async () => {
        const data = await getAnalytics()
        if (data)
            setAnalytics(data)
    }

    const handleDowload = async () => {
        await dowloadVendorList(pageNumber, pageSize, '', '')
    }

    useEffect(() => {
        getAnalyticsFunctioncaller()
    }, [])


    useEffect(() => {
        getAllVendorFunctioncaller()
    }, [pageNumber, search, field])
    return (
        <div id="dashboard-root"
            className="flex min-h-[1000px] w-full">
            <Sidebar />
            <Loader loading={loading} />
            <main id="main-content" className="flex-1 px-10 py-8">
                <Header title="Vendors" />
                <div id="vendors-page" className="mb-6">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <p className="text-gray-600">Manage your medical product vendors and partnerships</p>
                        </div>
                        <div className="flex space-x-3">
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                                <i className="fa-solid fa-filter mr-2"></i>
                                Filter
                            </button>
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center"
                                onClick={() => handleDowload()}
                            >
                                <i className="fa-solid fa-download mr-2"></i>
                                Export
                            </button>
                            <Link to="/vendor/add-vendor" id="add-vendor-btn" class="bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-4 py-2 text-sm font-medium flex items-center">
                                <i className="fa-solid fa-plus mr-2"></i>
                                Add Vendor
                            </Link>
                        </div>
                    </div>

                    <InfoCardsVendor data={analytics} />

                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="p-4 border-b flex items-center justify-between">

                            <div className="relative">
                                <input
                                    type="text"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search vendors..."
                                    className="border rounded-lg px-3 py-2 text-sm w-64"
                                />
                                <i className="fa-solid fa-search absolute right-3 text-gray-400" style={{ top: "0.375rem" }}></i>
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            {
                                <table className="w-full">
                                    <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <tr>

                                            <th className="p-4">Vendor</th>
                                            <th className="p-4">Contact Person</th>
                                            <th className="p-4">Phone Number</th>
                                            <th className="p-4">Address</th>
                                            <th className="p-4">Status</th>
                                            <th className="p-4">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">

                                        {

                                            loading ? (
                                                Array.from({ length: 5 }).map((_, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        {Array.from({ length: 7 }).map((_, colIndex) => (
                                                            <TableCell key={colIndex}>
                                                                <Skeleton variant="text" animation="wave" />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))
                                            ) : ((vendor || []).map((ele, i) => (
                                                <tr className="hover:bg-gray-50" key={i}>

                                                    <td className="p-4">
                                                        <div className="flex items-center">

                                                            <div className="w-10 h-10 rounded-lg flex items-center justify-center mr-3">
                                                                {ele?.vendorLogo ? (
                                                                    <img
                                                                        src={ele.vendorLogo}
                                                                        alt="Vendor"
                                                                        className="w-full h-full object-contain rounded-lg"
                                                                    />
                                                                ) : (
                                                                    <span className="text-gray-400">No Image</span>
                                                                )}
                                                            </div>

                                                            <div>
                                                                <div className="font-medium text-gray-800">{ele?.vendorName}</div>
                                                                <div className="text-xs text-gray-500">{ele?.createdAt}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="p-4">
                                                        <div>
                                                            <div className="text-gray-800">{ele?.contactPerson}</div>
                                                            <div className="text-xs text-gray-500">{ele?.emailAddress}</div>
                                                        </div>
                                                    </td>
                                                    <td className="p-4 text-gray-600">{ele?.phoneNumber}</td>
                                                    <td className="p-4 text-gray-600">{ele?.address?.streetAddress || "-"}</td>
                                                    <td className="p-4">
                                                        <span
                                                            className={`px-2 py-1 rounded-full text-xs
      ${ele?.vendorStatus === "Active" ? "bg-green-100 text-green-800" : ""}
      ${ele?.vendorStatus === "Pending" ? "bg-yellow-100 text-yellow-800" : ""}
      ${ele?.vendorStatus === "Inactive" ? "bg-red-100 text-red-800" : ""}`
                                                            }
                                                        >
                                                            {ele?.vendorStatus}
                                                        </span>
                                                    </td>
                                                    <td className="p-4">
                                                        <div className="flex space-x-2">

                                                            {/* Edit Vendor */}
                                                            <button
                                                                className="text-gray-500 hover:text-primary-600"
                                                                onClick={() => handleEdit(ele?._id)}
                                                            >
                                                                <i className="fa-solid fa-pencil"></i>
                                                            </button>

                                                            {/* Delete Vendor */}
                                                            <button
                                                                className="text-gray-500 hover:text-red-600"
                                                                onClick={() => handleDelete(ele?._id)}
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>

                                                </tr>
                                            )))
                                        }
                                    </tbody>
                                </table>
                                || <Skeleton count={10} />}
                        </div>
                        <Stack spacing={2} className="flex items-center mt-4 mb-6 mr-4 ">
                            <Pagination
                                count={totalPages}
                                onChange={handleChangePagination}
                                variant="outlined"
                                shape="rounded"
                            />
                        </Stack>

                        <Modal
                            open={open}
                            onClose={handleCancelDelete}
                            aria-labelledby="confirm-delete-modal"
                            aria-describedby="modal-to-confirm-deletion"
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'white',
                                    padding: '20px',
                                    borderRadius: '5px',
                                    boxShadow: 24,
                                    width: { xs: "80%", md: "500px" },
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="h6" gutterBottom>
                                    Are you sure you want to delete this Vendor?
                                </Typography>
                                <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                                    Yes
                                </Button>
                                <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                                    No
                                </Button>
                            </Box>
                        </Modal>
                    </div>
                </div>
            </main>
        </div>
    )
}
